import React, { useState, useEffect } from "react";
import useToken from "hooks/useToken";
import { useToast } from 'context/providers/ToastProvider';
import { Card, Col, Form, Row, Button, Badge } from 'react-bootstrap';
import SoftBadge from 'components/common/SoftBadge';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ModalVisualizarDetallesGasto from '../gastos/modal-registro-gasto/ModalVisualizarDetallesGasto';

const ListaActivoFijo = () => {


    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [activoFijo, setActivoFijo] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [responsableSeleccionado, setResponsableSeleccionado] = useState(0);


    const [filtroBusqueda, setFiltroBusqueda] = useState('');
    const [selectedGasto, setSelectedGasto] = useState(null);
    const [showGastoModal, setShowGastoModal] = useState(false);

    const base64ToFile = (base64String, fileName) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        return new File([blob], fileName, { type: blob.type });
    };

    const ObtenerGastoDetalle = async (id) => {
        var objDataSend = {};
        objDataSend.idGasto = id;

        const response = await fetch("/api/Gastos/ObtenerGastoDetalle", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(objDataSend)
        });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                let datosGastos = ObjDetalles.table2[0];
                if (datosGastos.vNotaVenta_Name) {
                    var file_Nota = base64ToFile(datosGastos.vNotaVenta_Base64, datosGastos.vNotaVenta_Name);
                    let datoGasto_ = { ...datosGastos };
                    datoGasto_.fileNota = file_Nota;
                    datoGasto_.idTipoMoneda = datosGastos.vMoneda === "MXN" ? 1 : datosGastos.vMoneda === "USD" ? 2 : null;
                    setSelectedGasto(datoGasto_);
                } else {
                    let datoGasto_ = { ...datosGastos };
                    datoGasto_.idTipoMoneda = datosGastos.vMoneda === "MXN" ? 1 : datosGastos.vMoneda === "USD" ? 2 : null;
                    setSelectedGasto(datoGasto_);
                }
                setShowGastoModal(true);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
        }
    };

    /**
     * Funcion para obtener los empleados
     */
    const obtenerListaEmpleados = async () => {
        setCargando(true);
        const response = await fetch("/api/ActivoFijo/ObtenerEmpleados",
            {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response && response.ok) {
            //console.log("response: ", response);
            const data = await response.json();
            //console.log("data: ", data);


            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles: ", ObjDetalles);

                setEmpleados(ObjDetalles.table2);

                // Selecciona el responsable solo la primera vez
                // NO llamar mostrarActivoFijo aquí


            } else {
                showErrorToast(data.vMessage);
            }
            setCargando(false);


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            setCargando(false);

        }
    };

    /**
    * Funcion para obtener los activos fijos
    */
    const mostrarActivoFijo = async (idUsuario) => {

        console.log("idUsuario: ", idUsuario);

        setCargando(true);

        var dataToSend = {};
        dataToSend.idUsuario = idUsuario;
        setActivoFijo([]);


        const response = await fetch("/api/ActivoFijo/ObtenerActivoFijo",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("response: ", response);
            const data = await response.json();
            //console.log("data: ", data);


            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles: ", ObjDetalles);

                setActivoFijo(ObjDetalles.table2);
                setCargando(false);

            } else {
                showErrorToast(data.vMessage);
                setCargando(false);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            setCargando(false);
        }
    };

    useEffect(() => {
        mostrarActivoFijo(0);         // Consulta activos de inmediato
        obtenerListaEmpleados();    // Carga empleados en paralelo
    }, []);

    const activosFiltrados = activoFijo.filter(activo => {
        const query = filtroBusqueda.toLowerCase();
        return (
            (activo.vNombreActivo && activo.vNombreActivo.toLowerCase().includes(query)) ||
            (activo.vDescripcion && activo.vDescripcion.toLowerCase().includes(query)) ||
            (activo.vNumeroRegistro && activo.vNumeroRegistro.toLowerCase().includes(query)) ||
            (activo.vNumeroSerie && activo.vNumeroSerie.toLowerCase().includes(query)) ||
            (activo.vEmpleadoResponsable && activo.vEmpleadoResponsable.toLowerCase().includes(query)) ||
            (activo.vUbicacionActivo && activo.vUbicacionActivo.toLowerCase().includes(query))
        );
    });

    return (
        <>
            <Card className="mb-3">
                <Card.Header>
                    <div className="d-flex flex-column gap-3">
                        <Row className="align-items-center g-3">
                            <Col xs={12} md={6} lg={4} xl={3}>
                                <div className="filter-group">
                                    <Form.Label className="fw-semibold mb-1">
                                        Responsable
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        aria-label="Filtrar por responsable"
                                        value={responsableSeleccionado}
                                        onChange={(e) => {
                                            setResponsableSeleccionado(e.target.value);
                                            mostrarActivoFijo(e.target.value);
                                        }}
                                        className="form-select-sm"
                                    >
                                        <option value="0">Todos los empleados</option>
                                        {empleados.map((empleado, index) => (
                                            <option key={empleado.idUsuario || index} value={empleado.idUsuario}>
                                                {empleado.vNombre} {empleado.vApellidos}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg="auto" className="ms-auto">
                                <div className="d-flex justify-content-end">
                                    <Link to="/administracion/activo-fijo/nuevo">
                                        <Button
                                            size="sm"
                                            variant="falcon-primary"
                                            className="d-flex align-items-center gap-2"
                                        >
                                            <i className="fas fa-plus" aria-hidden="true"></i>
                                            Nuevo Activo Fijo
                                        </Button>
                                    </Link>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} md={8} lg={6} xl={4} className="ms-auto">
                                <Form.Control
                                    type="text"
                                    placeholder="Buscar activos..."
                                    size="sm"
                                    value={filtroBusqueda}
                                    onChange={(e) => setFiltroBusqueda(e.target.value)}
                                />
                            </Col>
                        </Row>
                    </div>
                </Card.Header>

                <Card.Body className="p-0">
                    {cargando ? (
                        <div className="p-3">
                            {[...Array(3)].map((_, i) => (
                                <Card key={i} className="mb-3 shadow-sm">
                                    <Card.Body>
                                        <Skeleton height={20} width={100} className="mb-2" />
                                        <Skeleton height={15} width={250} className="mb-2" />
                                        <Skeleton height={15} width={180} />
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    ) : activosFiltrados.length > 0 ? (
                        <div className="p-3">
                            {activosFiltrados.map((activo) => {
                                const formattedDate = new Date(activo.dFechaCompra || activo.dCreatedDate).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric"
                                }).replace(/(?:^|\s)([a-z])/g, char => char.toUpperCase());

                                let categoriaName = "Otros";
                                switch (activo.idCategoria) {
                                    case 1: categoriaName = "Electrónica"; break;
                                    case 2: categoriaName = "Mobiliario"; break;
                                    case 3: categoriaName = "Vehículos"; break;
                                    case 4: categoriaName = "Inmuebles"; break;
                                    case 5: categoriaName = "Otros"; break;
                                }

                                return (
                                    <Card 
                                        key={activo.idActivoFijo} 
                                        className="mb-3 shadow-sm"
                                        style={{
                                            transition: 'all 0.2s ease-in-out',
                                            borderLeft: '4px solid #2c7be5'
                                        }}
                                    >
                                        <Card.Body>
                                            <Row className="align-items-center">
                                                {/* ID y Fecha */}
                                                <Col xs={12} md={2} className="mb-2 mb-md-0">
                                                    <div className="d-flex align-items-center gap-2 mb-1">
                                                        <h6 className="mb-0">
                                                            <Link
                                                                to={`/administracion/activo-fijo/editar/${activo.idActivoFijo}`}
                                                                className="fw-bold text-decoration-none text-primary"
                                                            >
                                                                #{activo.idActivoFijo}
                                                            </Link>
                                                        </h6>
                                                    </div>
                                                    <small className="text-muted"><b>{formattedDate}</b></small>
                                                    {activo.idGasto > 0 && (
                                                        <div className="mt-2">
                                                            <span
                                                                className="badge bg-soft-primary text-primary border border-primary-300 cursor-pointer"
                                                                style={{ cursor: 'pointer', fontSize: '0.73rem', padding: '0.35em 0.5em', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    ObtenerGastoDetalle(activo.idGasto);
                                                                }}
                                                            >
                                                                <i className="fas fa-link" style={{ fontSize: '0.65rem' }} />
                                                                Gasto Vinculado #{activo.idGasto}
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className="mt-2">
                                                        <Link to={`/administracion/activo-fijo/editar/${activo.idActivoFijo}`}>
                                                            <Button variant="outline-primary" size="sm">
                                                                Ver detalles
                                                            </Button>
                                                        </Link>
                                                    </div>
                                                </Col>

                                                {/* Información Principal */}
                                                <Col xs={12} md={6} className="mb-2 mb-md-0">
                                                    <div className="mb-2">
                                                        <h6 className="mb-1 text-dark fw-bold">
                                                            {activo.vNombreActivo}
                                                        </h6>
                                                        <p className="text-muted small mb-2">{activo.vDescripcion}</p>
                                                        <div className="d-flex flex-wrap gap-2 align-items-center">
                                                            <Badge bg="light" text="dark" className="border">
                                                                Nº Registro: {activo.vNumeroRegistro}
                                                            </Badge>
                                                            {activo.vNumeroSerie && (
                                                                <Badge bg="light" text="dark" className="border">
                                                                    S/N: {activo.vNumeroSerie}
                                                                </Badge>
                                                            )}
                                                            <Badge bg="info" className="text-white">
                                                                {categoriaName}
                                                            </Badge>
                                                        </div>
                                                    </div>
                                                    <div className="text-muted small">
                                                        <strong>Ubicación:</strong> {activo.vUbicacionActivo}
                                                    </div>
                                                    <div className="text-muted small">
                                                        <strong>Responsable:</strong> {activo.vEmpleadoResponsable || "Sin responsable"}
                                                    </div>
                                                </Col>

                                                {/* Costo y Estado */}
                                                <Col xs={12} md={4} className="text-md-end">
                                                    <div className="mb-2">
                                                        <span className="text-muted d-block small">Costo de Adquisición</span>
                                                        <h4 className="mb-0 fw-bold text-dark">
                                                            {Number(activo.dCostoAdquisicion).toLocaleString("es-MX", {
                                                                style: "currency",
                                                                currency: "MXN"
                                                            })}
                                                        </h4>
                                                    </div>
                                                    <div className="mt-2">
                                                        <SoftBadge
                                                            bg={activo.iEstadoActivo == 1 ? "success" : activo.iEstadoActivo == 0 ? "danger" : "warning"}
                                                        >
                                                            {activo.iEstadoActivo == 1 ? "Activo" : activo.iEstadoActivo == 0 ? "No Activo" : "En reparación"}
                                                        </SoftBadge>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <h5 className="text-muted">No se encontraron activos fijos</h5>
                        </div>
                    )}
                </Card.Body>
            </Card>

            {showGastoModal && selectedGasto && (
                <ModalVisualizarDetallesGasto
                    show={showGastoModal}
                    selectedGasto={selectedGasto}
                    onClose={() => {
                        setShowGastoModal(false);
                        setSelectedGasto(null);
                    }}
                />
            )}
        </>
    );

}

export default ListaActivoFijo;